/** ESCHER FALLS — 简体中文。 */

import type { Strings } from './ja';

export const ZH_HANS: Strings = {
  pour: '放水',
  lever: '拉杆',
  leverAria: '拉动拉杆',
  retry: '重新开始',
  again: '再来一次',
  next: '下一关',
  share: '分享这一张',
  shareFailed: '无法分享',
  rotateLeft: '视角向左旋转',
  rotateRight: '视角向右旋转',
  tiltUp: '抬高视角',
  tiltDown: '降低视角',
  topDown: '俯视',
  water: (left, total) => `水量 ${left} / ${total}`,
  moves: (left, total) => `步数 ${left} / ${total}`,
  timeLeft: (time) => `剩余 ${time}`,
  drops: (n) => `水滴 ${n}`,

  resultClear: '通了',
  resultFail: '没通',
  clearTitle: '通水',
  fail: {
    time: '时间用尽了',
    moves: '步数用尽了',
    drywell: '水流进了枯井',
    water: '水用尽了',
    deadend: '水落进了断头路',
  },
  extendByAd: '看广告延长 30 秒',
  extendByDrops: (cost) => `用 ${cost} 水滴延长 30 秒`,
  multiplyByAd: (mult) => `看广告获得 ×${mult} 水滴`,

  stages: '关卡',
  settingsAria: '设置',
  menuAria: '菜单',
  back: '返回',
  loop1: '第一周',
  loop2: '第二周',
  loopNote: '第二周的步数与时间更紧。记录与第一周分开保存。',
  shop: '商店',
  groupMain: '正篇',
  groupExtra1: '额外关',
  groupExtra2: '额外关 其二',
  freeTrial: '试玩',
  notPurchased: (n, name) => `${n} ${name}（未购买）`,
  lockedStage: '未解锁的关卡',
  extraLockedFree: '第一关《逆流之瀑》可免费玩。其余在设置（≡）中购买后开启。',
  extraLocked: '在设置（≡）中购买后开启。',
  extra2Locked: '第11关起，通过第1–10关后开启。',
  extra2LockedUnowned: '在设置（≡）中购买，并通过第1–10关后，第11关起开启。',
  extra2Note: '通过全部额外关后开启。',
  progress: (cleared, total) => `正篇 ${cleared} / ${total} 通水`,
  totalTime: (time) => `合计 ${time}`,
  totalNone: '合计 —',

  settings: '设置',
  bgm: '环境音',
  se: '音效',
  testSound: '试听',
  audioStatus: (state) => `声音状态：${state}`,
  audioState: {
    locked: '未解锁（触摸屏幕一次即可启动）',
    running: '正在播放',
    suspended: '已暂停',
  },
  demoNote: (n) => `网页试玩版可玩前 ${n} 关。全部 42 关在应用里。`,
  demoGet: '到 App Store 获取',
  // — 今日の一面（日替わり）
  dailyTitle: '今日一关',
  dailyLoading: '加载中…',
  dailyOffline: '无法连接，今日一关暂时打不开',
  dailyPlay: '开始',
  dailyCleared: (time: string) => `已通过 ${time}`,
  archiveTitle: '往日关卡',
  upcomingTitle: '后续关卡',
  archiveLocked: '最近3天免费。购买额外关后，更早的关卡全部开放',
  language: '语言',
  languageAuto: '跟随设备',
  palette: '配色',
  worn: '使用中',
  owned: '已拥有',
  buyDrops: '购买水滴',
  restore: '恢复购买',
  writeReview: '为这个应用评分',
  moreApps: '开发者的其他作品',
  restoreChecking: '正在确认…',
  restoreDone: (n) => `已恢复 ${n} 项`,
  restoreNone: '没有可恢复的项目',
  restoreFailed: '无法恢复',
  chooseStage: '选择关卡',
  resume: '继续',

  prizeLabel: '通关奖励',
  awardLabel: '称号',
  toExtra: '前往额外关',
  toLoop2: '前往第二周',
  toStart: '回到起点',
  allClearTitle: '走遍',
  allClearBody: (n) => `${n} 条水路全部通了水`,
  multiplyTimes: (mult) => `看广告获得 ${mult} 倍`,
  noteRank: '称号会留在记录里，显示在关卡列表的上方。',
  noteLoop2: '第二周已开启。步数与时间更紧。',
  notePartOne: '至此是第一部。水，还没有往上流。',
  inviteTry: '试玩额外关 一',
  inviteOpen: '开启额外关 其一 20 关',
  dateLine: (d) => `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`,

  completionTitle: '渡越无穷者',
  rank: {
    none: '—',
    sovereign: '御水者',
    architect: '瀑布的设计者',
    mason: '石匠',
    apprentice: '学徒',
    wayfarer: '旅人',
  },

  skin: {
    hakushi: '白纸',
    ai: '蓝',
    koke: '苔',
    shu: '朱',
    sumi: '墨',
  },

  product: {
    drops600: '水滴 600',
    drops1600: '水滴 1,600',
    drops5000: '水滴 5,000',
    noads: '去除广告',
    extras: '额外关 其一 21 关（无广告）',
  },
};
